var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmployment(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#fff;}.a{stroke:#fff;opacity:0;}.c{stroke:none;}.d{fill:none;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(10413 3263)"
  }, /*#__PURE__*/React.createElement("g", {
    className: "a",
    transform: "translate(-10413 -3263)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "c",
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 23
  })), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M18.779,2.267H13.638V1.7a1.7,1.7,0,0,0-1.7-1.7H7.4A1.7,1.7,0,0,0,5.7,1.7v.567H.567A.568.568,0,0,0,0,2.833V15.3A1.7,1.7,0,0,0,1.7,17H17.642a1.7,1.7,0,0,0,1.7-1.7V2.843A.55.55,0,0,0,18.779,2.267ZM6.838,1.7A.567.567,0,0,1,7.4,1.133h4.533A.567.567,0,0,1,12.5,1.7v.567H6.838ZM17.989,3.4,16.23,8.679a.566.566,0,0,1-.537.388H12.5V8.5a.567.567,0,0,0-.567-.567H7.4a.567.567,0,0,0-.567.567v.567H3.65a.566.566,0,0,1-.537-.388L1.353,3.4ZM11.371,9.067V10.2h-3.4V9.067ZM18.209,15.3a.567.567,0,0,1-.567.567H1.7a.567.567,0,0,1-.567-.567V6.325l.9,2.712A1.7,1.7,0,0,0,3.65,10.2H6.838v.567a.567.567,0,0,0,.567.567h4.533a.567.567,0,0,0,.567-.567V10.2h3.188A1.7,1.7,0,0,0,17.3,9.038l.9-2.712Zm0,0",
    transform: "translate(-10411 -3259)"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployment);
export default __webpack_public_path__ + "static/media/employment.5a1d9a553a2b399e6d7f9b67b06389dc.svg";
export { ForwardRef as ReactComponent };